import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useIntercom } from 'react-use-intercom'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import {
  IconLiveChat,
  IconLogout,
  IconShareFeedback,
} from 'Stories/Icon/Icon.stories'
import { login } from 'Router/routes'
import { getIsArtist, getUserSelector } from 'Redux/selectors/auth'
import { getCampaigns } from 'Redux/selectors/campaigns'
import SidebarLink from '../SidebarLink'
import { SidebarBottomProps } from './SideBarBottomProps'

import {
  SidebarLinkItem,
  SidebarIconBlock,
  SidebarLinkText,
  Bottom,
  BottomInner,
  Logout,
  StyledPopupButton,
} from './styles'

const SideBarBottom: FunctionComponent<SidebarBottomProps> = ({
  collapse,
  handleLogOut,
}) => {
  const { t } = useTranslation()
  const { show } = useIntercom()

  const user = useSelector(getUserSelector)
  const isArtist: boolean = useSelector(getIsArtist)
  const campaigns = useSelector(getCampaigns)

  const isAppropriateStatus = Boolean(
    campaigns.find(
      ({ status }) =>
        status === 'ended' || status === 'scheduled' || status === 'running'
    )
  )

  const isFeedExist = Boolean(campaigns.find(({ is_feed }) => is_feed))

  return (
    <Bottom>
      <BottomInner>
        <SidebarLinkItem collapse={collapse} onClick={show}>
          <SidebarIconBlock>
            <IconLiveChat />
          </SidebarIconBlock>
          {!collapse ? (
            <SidebarLinkText>{t('sidebar.liveChat')}</SidebarLinkText>
          ) : (
            <SidebarLinkText />
          )}
        </SidebarLinkItem>
      </BottomInner>

      {isArtist && (
        <>
          <Desktop>
            {isAppropriateStatus || isFeedExist ? (
              <div>
                <SidebarLinkItem collapse={collapse}>
                  {/* Typeform at least one campaign exists with the status either ended or scheduled or running or at least one campaign has is_feed flag */}
                  <StyledPopupButton
                    id="Xh2CXR6m"
                    collapse={collapse}
                    hidden={{
                      email: user?.email,
                      is_feed: isFeedExist ? 'yes' : 'no',
                    }}
                  >
                    <SidebarIconBlock>
                      <IconShareFeedback />
                    </SidebarIconBlock>
                    {!collapse ? (
                      <SidebarLinkText>
                        {t('sidebar.shareFeedback')}
                      </SidebarLinkText>
                    ) : (
                      <SidebarLinkText />
                    )}
                  </StyledPopupButton>
                </SidebarLinkItem>
              </div>
            ) : null}
          </Desktop>

          <Mobile>
            {campaigns.find(
              ({ status }) =>
                status === 'ended' ||
                status === 'scheduled' ||
                status === 'running'
            ) ? (
              <div>
                <SidebarLinkItem collapse={collapse}>
                  {/* Typeform at least one campaign exists with the status either ended or scheduled or running or at least one campaign has is_feed flag */}
                  <StyledPopupButton
                    id="Xh2CXR6m"
                    collapse={collapse}
                    hidden={{
                      email: user?.email,
                      is_feed: isFeedExist ? 'yes' : 'no',
                    }}
                  >
                    <SidebarIconBlock>
                      <IconShareFeedback />
                    </SidebarIconBlock>
                    {!collapse ? (
                      <SidebarLinkText>
                        {t('sidebar.shareFeedback')}
                      </SidebarLinkText>
                    ) : (
                      <SidebarLinkText />
                    )}
                  </StyledPopupButton>
                </SidebarLinkItem>
              </div>
            ) : null}
          </Mobile>
        </>
      )}

      <Logout>
        <SidebarLink
          icon={<IconLogout />}
          route={login}
          title={t('sidebar.logout')}
          onClick={handleLogOut}
        />
      </Logout>
    </Bottom>
  )
}

export default SideBarBottom
